var map = {
	"./giftcard_desktop_failed.svg": "1cce",
	"./giftcard_details_failed.svg": "0497",
	"./giftcard_failed.svg": "601e",
	"./investment_desktop_failed.svg": "e4dc",
	"./investment_details_failed.svg": "d9c7",
	"./investment_failed.svg": "4761",
	"./mkt_desktop_failed.svg": "aab0",
	"./mkt_details_failed.svg": "a08a",
	"./mkt_failed.svg": "dcde",
	"./payment_desktop_failed.svg": "742c",
	"./payment_details_failed.svg": "c804",
	"./payment_failed.svg": "f982",
	"./topup_desktop_failed.svg": "33c0",
	"./topup_details_failed.svg": "6bcd",
	"./topup_failed.svg": "1a3a",
	"./voucher_desktop_failed.svg": "690e",
	"./voucher_details_failed.svg": "c7d6",
	"./voucher_failed.svg": "e8d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6d2";